/*
 * General child scripts
 */
import $ from "jquery";

$(document).ready(function() {

  /*
   * Allow link titles to exist for ADA/SEO but temporarily disable all tooltips on hover
   *
   */
  var links = document.getElementsByTagName( 'a' );
  for (var i = 0; i < links.length; i++) {
    links[i]._title = links[i].title;
    links[i].onmouseover = function() {
      this.title = '';
    }
    links[i].onmouseout = function() {
      this.title = this._title;
    }
  }
  // $( 'a' ).on({
  //   mouseenter: function () {
  //     title = $( this ).attr( 'title' );
  //     $( this ).attr( { 'title': '' } );
  //   },
  //   mouseleave: function () {
  //     $( this ).attr( { 'title': title } );
  //   }
  // });

  $( window ).on( 'resize', function() {
    /*
     * Fix mobile menu primary menu from parent - doesn't reset on window resize
     *
     */
    if ($( '#site-navigation' ).hasClass( 'open' )) {
      $( '#site-navigation' ).removeClass( 'open' );
      $( '#masthead' ).removeClass( 'menu-open' );
    }
  });

  /*
   * Scroll button at bottom of hero
   *
   */
  $( '#scroll-to-content' ).on( 'click', function(e) {
    e.preventDefault();

    $( 'html, body' ).animate({
      scrollTop: $( '#content' ).offset().top,
    }, $( '#content' ).offset().top);
  });

  /*
   * Expand sidebar lists
   *
   */
  $( '.sidebar li' ).on( 'click', function(e) {
    if ( $( this ).hasClass( 'active' ) ) {
      e.preventDefault();
    }
    if ( $( this ).parent( 'ul' ).hasClass( 'expanded' ) ) {
      console.log('test1');
      $( this ).parent( 'ul' ).removeClass( 'expanded' );
      $( this ).parent( 'ul' ).children( 'li' ).not( '.active' ).slideUp();
    } else {
      console.log('test2');
      $( this ).parent( 'ul' ).addClass( 'expanded' );
      $( this ).parent( 'ul' ).children( 'li' ).slideDown();
    }
  });

  /*
   * Course Hole-by-Hole/Overview/History buttons
   *
   */
  if ( $( 'body' ).hasClass( 'single-course' ) ) {
    $( '#single-course-holes' ).css( 'opacity', '1' );
    $( '.slide-main-nav-button' ).on( 'click', function(e) {
      e.preventDefault();
      if ( ! $( this ).hasClass( 'active' ) ) {
        var target = $ ( $( this ).data( 'target' ) );
        $( '.slide-main-nav-button' ).removeClass( 'active' );
        target.parent().children( 'div' ).css( 'opacity', '0' );
        $( this ).addClass( 'active' );
        target.parent().append( target );
        target.css( 'opacity', '1' ).fadeIn();
      } else {
        return null;
      }
    });
  }
  /*
   * Revinate Contact Form submissions (footer form)
   *
   */
  setTimeout( function() {
    $( '#nf-form-2-cont' ).find( 'form' ).each( function() {
      $( this ).attr( {
        id: 'revinate_contact_api_form',
        token: 'd0e72676-9be7-4938-b811-a6d2706f92d3'
      }).on( 'submit', function(e) {
        revFormOnSubmit();
        e.preventDefault();
      });
    });
  }, 2000);

  /*
   * The Grid Nines (for other version The Nines see slick-init.js)
   *
   */
  // Default to front 9
  function gridHolesDefault() {
    $('.golf-course-grid').find('.nav-front-9').each(function() {
      $(this).addClass('active');
    });
  }
  gridHolesDefault();

  // Activate front 9
  function gridHolesActivateFront9() {
    $('.golf-course-grid').find('.course-grid').each(function() {
      $(this).addClass('front-9-active');
    });
  }
  gridHolesActivateFront9();

  // Swap front 9 and back 9 on menu button clicks
  $('.the-grid-nines').find('.nav-button').each(function() {
    var button = $(this);
    button.on('click', function() {
      if (button.hasClass('nav-front-9')) {
        if (! button.hasClass('active')) {
          $('.the-grid-nines').find('.nav-button').each(function() {
            $(this).removeClass('active');
          });
          button.addClass('active');
          $('.golf-course-grid').find('.course-grid').each(function() {
            $(this).removeClass('back-9-active');
            $(this).addClass('front-9-active');
          });
        }
      } else if (button.hasClass('nav-back-9')) {
        if (! button.hasClass('active')) {
          $('.the-grid-nines').find('.nav-button').each(function() {
            $(this).removeClass('active');
          });
          button.addClass('active');
          $('.golf-course-grid').find('.course-grid').each(function() {
            $(this).removeClass('front-9-active');
            $(this).addClass('back-9-active');
          });
        }
      }
    });
  });

  /*
   * Pass an element object and return a boolean based on if
   * the element's coordinates are within the viewport's coordinates.
   */
  function isVisible(element) {
    var coordinates = element.getBoundingClientRect();

    //-- Bottom or right edges aren't visible.
    if (
      coordinates.right > window.innerWidth ||
      coordinates.bottom > window.innerHeight
    ) {
      return false;
    }

    //-- Top or left edges aren't visible.
    if (
      coordinates.top < 0 ||
      coordinates.left < 0
    ) {
      return false;
    }

    return true;
  }
});